import { createElement, useState } from 'react';
import { ElementFactory, Serializer, SvgRegistry } from 'survey-core';
import { ReactQuestionFactory } from 'survey-react-ui';
import { PropertyGridEditorCollection } from 'survey-creator-react';
import { MediaItem } from '~/ui-components';
import { CameraIcon } from './customIcons';
import { UploadMediaComponent } from './UploadMediaComponent';
import { QuizQuestionMediaUploader, UploadMediaQuizQuestion } from './UploadMediaQuestionClasses';

export const CUSTOM_IMAGE_TYPE = 'image-upload';

export class ImageUploadQuestion extends UploadMediaQuizQuestion {
   getType() {
      return CUSTOM_IMAGE_TYPE;
   }
}

export function registerImageUploadQuestion() {
   ElementFactory.Instance.registerElement(CUSTOM_IMAGE_TYPE, name => {
      return new ImageUploadQuestion(name);
   });
}

// Add an icon to display in tool box
SvgRegistry.registerIconFromSvg(CUSTOM_IMAGE_TYPE, CameraIcon);

type ImageUploadComponentProps = {
   mediaType: string | undefined;
   imageId: number | undefined;
   onUploadImage: (imageData: any) => void;
   caption: string | undefined;
};

const ImageUploadComponent = ({
   mediaType,
   imageId,
   onUploadImage,
   caption,
}: ImageUploadComponentProps) => {
   const [hideInfoMsg, setHideInfoMsg] = useState(!!imageId);

   let initialValue = undefined;
   let type: MediaItem['type'] | undefined = undefined;
   if (mediaType) {
      type = 'GuideImage';
   }
   if (type && imageId) {
      initialValue = {
         id: imageId,
         type: type,
      };
   }

   return (
      <UploadMediaComponent
         hideInfoMsg={hideInfoMsg}
         setHideInfoMsg={setHideInfoMsg}
         onUploadMedia={onUploadImage}
         initialMediaValue={initialValue}
         mediaFilter="guide_main_image"
         caption={caption}
      />
   );
};

Serializer.addClass(
   CUSTOM_IMAGE_TYPE,
   [
      {
         name: 'mediaType',
         type: 'string',
         visible: false,
      },
      {
         name: 'imageId',
         type: 'number',
         visible: false,
      },
      {
         name: 'altText',
         type: 'input',
         category: 'general',
         visibleIndex: 2,
      },
      {
         name: 'caption',
         type: 'input',
         category: 'general',
         visibleIndex: 3,
      },
   ],
   () => new ImageUploadQuestion(''),
   'question'
);

export class QuizQuestionImageUploader extends QuizQuestionMediaUploader {
   handleImageUpload = (data: any) => {
      this.question.imageId = data.imageId;
      this.question.mediaType = data.mediaType;
   };

   renderImageUploader() {
      return (
         <ImageUploadComponent
            mediaType={this.mediaType}
            imageId={this.imageId}
            onUploadImage={this.handleImageUpload}
            caption={this.caption}
         />
      );
   }

   renderElement() {
      return <div>{this.renderImageUploader()}</div>;
   }
}

ReactQuestionFactory.Instance.registerQuestion(CUSTOM_IMAGE_TYPE, props => {
   return createElement(QuizQuestionImageUploader, props);
});

PropertyGridEditorCollection.register({
   fit: prop => {
      return prop.type === 'image';
   },
   getJSON: () => {
      return {
         type: CUSTOM_IMAGE_TYPE,
      };
   },
});
